import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import CustomSearch from './CustomSearch'

export default function index() {
  return (
    <div>
        <Header/>
        <CustomSearch/>
        <Footer/>
    </div>
  )
  
}
